// extracted by mini-css-extract-plugin
module.exports = {"aside":"style_aside__3qorA","row":"style_row__12CXY"};